var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "tx_history_statistics"
    }
  }, [_c('section', {
    staticClass: "stats"
  }, [_c('dl', [_c('dd', [_vm._v(" " + _vm._s(_vm.prefix) + " Addresses "), _c('TooltipMeta', {
    attrs: {
      "content": "Number of unique addresses on Avalanche in the selected time-interval",
      "color": '#2196f3'
    }
  })], 1), _c('dt', [_vm._v(" " + _vm._s(_vm.aggregates.addressCount.toLocaleString()) + " ")])]), _c('dl', [_c('dd', [_vm._v(" " + _vm._s(_vm.prefix) + " Assets "), _c('TooltipMeta', {
    attrs: {
      "content": "Number of distinct assets transferred on Avalanche in the selected time-interval",
      "color": '#2196f3'
    }
  })], 1), _c('dt', [_vm._v(" " + _vm._s(_vm.aggregates.assetCount.toLocaleString()) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }